<template>
  <Select
    v-model="myValue"
    class="custom-select"
    size="large"
    :disabled="disabled"
    @on-change="changeType"
    @on-select="selectedType"
  >
    <Option
      v-for="item in typeList"
      :key="item.name"
      :value="item.name"
      :label="item.name"
      :disabled="!item.about.installed"
    >
      <div class="title">{{ item.name }}</div>
      <Tooltip
        v-if="!item.about.installed"
        class="tag"
        :content="$t('plugins.installTip')"
        placement="top"
        max-width="200px"
        transfer
      >
        <Button type="primary" size="small" @click="routeToInstallPage(item.name)">
          {{ $t('common.install') }}
        </Button>
      </Tooltip>
      <div class="info">{{ item.about.author.name }}, {{ item.about.author.email }}</div>
      <p class="description">
        {{ i18nLabel(item.about.description) }}
      </p>
    </Option>
  </Select>
</template>

<script>
import nodeID from '@/mixins/nodeID'
import currentLang from '@/mixins/currentLang'
import installPlugin from '@/mixins/installPlugin'
import { getMetadataByCategory } from '@/api/metadata'

export default {
  name: 'ConfKeyTypesSeletor',
  props: {
    value: { type: String, default: '' },
    category: { type: String, default: '' }, // sources | sinks | functions | ops | connections
    disabled: { type: Boolean, default: false },
    params: { type: Object, default: () => {} }, // api params
  },

  mixins: [nodeID, currentLang, installPlugin],

  data() {
    return {
      typeList: [],
    }
  },

  computed: {
    myValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },

  created() {
    this.getConfKeyTypeList()
  },

  methods: {
    // get conf key types by category
    getConfKeyTypeList() {
      if (this.category) {
        getMetadataByCategory(this.category, { nodeID: this.nodeID }, this.params).then((res) => {
          const { data } = res
          this.typeList = data || []
        })
      }
    },

    changeType(val) {
      this.$emit('onChange', val)
    },

    selectedType(val) {
      const findData = this.typeList.find((type) => type.name === val.value)
      this.$emit('onSelected', findData)
    },

    // Install Plugin
    routeToInstallPage(name) {
      this.goToInstallPluginPage(this.category, name)
    },
  },
}
</script>
